import { Box, ColorOptions, Loader, ModalDialogNew, ModBox, Spacer, Text } from '@jfs/ui-new'
import { FC, useEffect, useState } from 'react'
import { Dimensions, FlatList } from 'react-native'
import { useKeyboard } from '../../../comps/KeyboardAwareModal/keyboardHook'
import { SvgImage } from '../../../comps/SvgImage'
import { TextInputWithLabelOnBorder } from '../../../comps/TextInputWithLabelOnBorder'
import { useLazyApiData, useStores } from '../../../data/store'
import { Colors } from '../../../util/util'
import { SearchBar } from '../SearchBar'
import styles from './styles'

const height = Dimensions.get('screen').height

const SelectCity: FC = ({ ...props }: any) => {
  const { getLocationList, locationInfo } = useStores((root) => ({
    getLocationList: root.billPayments.getLocationListApi,
    locationInfo: root.billPayments.transaction.locationInfo,
  }))

  const [getLocationListApi, { state: locationState }] = useLazyApiData(getLocationList)
  const [searchText, setSearchText] = useState('')
  const [showModal, setShowModal] = useState(false)
  const [keyboardHeight] = useKeyboard()

  const cityData: any = ((state: any) => {
    let selectedState = locationInfo?.state?.filter((item: any) => item.name === state)?.[0] ?? []
    if (selectedState) {
      selectedState = JSON.parse(JSON.stringify(selectedState))
    }
    const cities = selectedState?.city?.map((item: any, index: any) => {
      return {
        id: (index + 1).toString(),
        title: item,
      }
    })
    return cities
  })(props?.allValues?.state)

  const getCities = (searchText: string) => {
    if (searchText !== '') {
      const filteredState = cityData?.filter((item) => {
        return item?.title?.toLowerCase().includes(searchText?.toLowerCase())
      })
      return filteredState ?? []
    } else {
      return cityData
    }
  }

  useEffect(() => {
    getLocationListApi()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const onChangeText = (text: string) => {
    setSearchText(text)
  }

  const selectedState = props?.allValues?.state

  const renderItem = ({ item }: any) => {
    return (
      <Box
        key={item?.id}
        underlayColor={'TRANSPARENT'}
        onPress={() => {
          const { setFieldValue, fieldName } = props
          setFieldValue(fieldName, item.title)
          showHideModal(false)
        }}
        testID={'city-' + item?.title?.replaceAll(' ', '')}
        justifyContent={'center'}
        width="100%">
        <Box pv={12} width={'100%'}>
          <Text testID="title" {...styles.title}>
            {item?.title}
          </Text>
        </Box>
      </Box>
    )
  }

  const onEndReached = () => {
    console.log('********* onEndReached: ' + Math.ceil(locationInfo.state?.length / 20))
  }

  const showHideModal = (value) => {
    setShowModal(value)
  }

  return (
    <Box>
      <Box opacity={selectedState !== '' ? 1 : 0.6}>
        <TextInputWithLabelOnBorder
          editable={false}
          onPressIn={() => selectedState && showHideModal(true)}
          onPress={() => selectedState && showHideModal(true)}
          {...props}
        />
      </Box>

      <ModalDialogNew type={'bottom'} animate={true} show={showModal} backgroundColor="TRANSPARENT">
        <Box
          height={keyboardHeight === 0 ? height - 140 : height - 140 - keyboardHeight}
          borderTopLeftRadius={24}
          borderTopRightRadius={24}
          backgroundColor="WHITE"
          ph={25}>
          <ModBox f={1} justify="center" align="center" show={locationState === 'pending'}>
            <Loader />
            <Spacer size={10} direction="vertical" />
            <Text color={Colors.BLACK_14 as ColorOptions} fontFamily="SourceSans3-SemiBold" fontSize={14}>
              Loading...
            </Text>
          </ModBox>
          <ModBox show={locationState !== 'pending'} backgroundColor="WHITE" overflow={'auto'}>
            <Spacer size={32} direction="vertical" />
            <Box flexDirection={'row'} justifyContent="space-between" align="center">
              <Text color={Colors.BLACK_14 as ColorOptions} fontFamily="JioType-Black" fontSize={24} lineHeight={28}>
                {props?.placeholder}
              </Text>
              <Box
                onPress={() => {
                  showHideModal(false)
                }}
                testID="close-modal"
                underlayColor={'TRANSPARENT'}>
                <SvgImage imageName="Close" />
              </Box>
            </Box>

            <Box paddingTop={24} paddingBottom={8} width={'100%'}>
              <SearchBar
                onChange={onChangeText}
                value={searchText}
                placeholder="Search City"
                borderRadius={8}
                theme={{ bodyBgColor: '#fff', bodyTextColor: '#B5B5B5' as ColorOptions }}
              />
            </Box>

            <FlatList
              horizontal={false}
              contentContainerStyle={{ flexGrow: 1, width: '100%', alignItems: 'stretch' }}
              renderItem={renderItem}
              data={getCities(searchText)}
              onEndReached={onEndReached}
              keyExtractor={(item) => item.id}
              style={{ width: '100%' }}
            />
          </ModBox>
        </Box>
      </ModalDialogNew>
    </Box>
  )
}
export default SelectCity
